import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const goToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

export default function UpperButton() {
  return (
    <button
      onClick={goToTop}
      className="w-10 h-10 rounded-full p-4 bg-[#FF6809] text-white fixed bottom-5 right-5 z-40 flex justify-center items-center"
    >
      <FontAwesomeIcon icon={faAngleUp} />
    </button>
  );
}
